import { CircularProgress } from '@mui/material';
import _ from 'lodash';
import { TitledPage } from '@client/new/components/Misc';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { InboxViewModel, useInboxViewModel } from './useInbox.viewModel';
import auth from '@client/components/auth';
import { EnableDirectMessage } from './EnableDirectMessage';
import { InboxContainer } from './Inbox';
import { Typography } from '@design-system/components/typography/typography';

type InboxPageProps = {
  params: {
    influencerId: string;
  };
};

export const InboxPage = (props: InboxPageProps) => {
  const influencerId = props.params.influencerId
    ? parseInt(props.params.influencerId)
    : auth.getUser().influencerId;
  const viewModel = useInboxViewModel({ influencerId });

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="Direct Messages">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage title="Direct Messages">
          <InboxContent {...data} />
        </TitledPage>
      )}
    />
  );
};

const InboxContent = (p: InboxViewModel) => {
  if (p.hideDirectMessages)
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <Typography>Feature available only with subscription</Typography>
      </div>
    );

  switch (p.isMessagingEnabled) {
    case true:
      return <InboxContainer influencerId={p.influencerId} />;
    case false:
      return <EnableDirectMessage {...p} />;
  }
};
